<template>
  <div id="app">
    <div v-if="isWeChat" class="wechat-tip">
      <div class="tip-content">
        <van-icon name="share" size="40" color="#1989fa" />
        <h3>请在浏览器中打开</h3>
        <p>检测到您在微信中访问</p>
        <p>请点击右上角 ··· 选择"在浏览器中打开"</p>
        <div class="arrow-guide">
          <div class="arrow"></div>
        </div>
      </div>
    </div>
    <template v-else>
      <keep-alive include="PanSearch">
        <router-view/>
      </keep-alive>
      <van-tabbar v-model="active" fixed placeholder safe-area-inset-bottom v-if="showTabbar">
        <van-tabbar-item icon="shopping-cart-o" to="/">内部资源</van-tabbar-item>
        <!-- <van-tabbar-item icon="search" to="/external">全网外部资源</van-tabbar-item> -->
        <van-tabbar-item icon="friends-o" to="/new-pan">全网外部资源</van-tabbar-item>
        <van-tabbar-item icon="user-o" to="/profile">个人中心</van-tabbar-item>
      </van-tabbar>
    </template>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      active: 0,
      isWeChat: false
    };
  },
  mounted() {
    this.checkWeChat();
  },
  computed: {
    showTabbar() {
      const hidePaths = ['/login', '/register'];
      const isDetailPage = this.$route.path.startsWith('/new-pan/detail/');
      return !hidePaths.includes(this.$route.path) && !isDetailPage;
    }
  },
  watch: {
    '$route.path': {
      handler(newPath) {
        if (newPath === '/' || newPath.startsWith('/internal')) {
          this.active = 0;
        } else if (newPath === '/external' || newPath === '/search' || newPath === '/ranking-more') {
          this.active = 1;
        } else if (newPath === '/new-pan' || newPath.startsWith('/new-pan/detail/')) {
          this.active = 1;
        } else if (newPath === '/profile') {
          this.active = 2;
        }
      },
      immediate: true
    }
  },
  methods: {
    checkWeChat() {
      const ua = navigator.userAgent.toLowerCase();
      this.isWeChat = ua.indexOf('micromessenger') !== -1;
    }
  }
};
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  background: #f5f5f5;
  -webkit-font-smoothing: antialiased;
}

#app {
  min-height: 100vh;
  background: #f5f5f5;
}

.wechat-tip {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.tip-content {
  text-align: center;
  color: #fff;
}

.tip-content h3 {
  font-size: 20px;
  margin: 16px 0 12px;
}

.tip-content p {
  font-size: 14px;
  margin: 6px 0;
  opacity: 0.9;
}

.arrow-guide {
  margin-top: 30px;
  position: relative;
  height: 60px;
}

.arrow {
  position: absolute;
  right: 50%;
  top: 0;
  margin-right: -80px;
  width: 0;
  height: 0;
  border-left: 20px solid transparent;
  border-right: 20px solid transparent;
  border-bottom: 30px solid #ff6b6b;
  animation: arrowBounce 1s infinite;
}

.arrow::after {
  content: '';
  position: absolute;
  top: 8px;
  left: -12px;
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid transparent;
  border-bottom: 18px solid #ff6b6b;
}

@keyframes arrowBounce {
  0%, 100% {
    transform: translateY(0);
    opacity: 1;
  }
  50% {
    transform: translateY(10px);
    opacity: 0.5;
  }
}
</style>
